// NOTE : do not edit this file
//
// it is auto-generated to update the prefix to a value that matches the environment
// if you do want to change this file, remember to update the build pipeline accordingly

export const prefixHolder = {
  Gateway: 'https://id.chatclb.com',
  Backend: 'https://api.chatclb.com',
  WebFrontend: 'https://chatclb.com',
  WebAdminFrontend: "https://admin.chatclb.com",
  WebSocket: 'wss://api.safelyq.com',
};

export const oneSignalAdminAppId = '1e1f2152-9efa-4c9b-9e91-62bdb5006194'; 